












import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { AuthService as _authService } from '@/services/auth.service'
import router from '@/router'
import Navigation from '@/components/Navigation.vue'

@Component({
  components: {
    Navigation
  }
})
export default class App extends Vue {
  created() {
    // before a request is made start the nprogress
    axios.interceptors.request.use(config => {
      (window as any).NProgress.start()
      return config
    })

    // before a response is returned stop nprogress
    axios.interceptors.response.use(response => {
      // Handle notification
      const notifications = response.data && response.data.notifications
      if (notifications && notifications.length) {
        for (const notification of notifications) {
          Vue.notify({
            group: 'notifications',
            type: notification.type,
            title: notification.title,
            text: notification.message
          })
        }
      }

      (window as any).NProgress.done()
      return response
    }, error => {
      // Handla Unauthorize
      if (error.response) {
        if (error.response.status === 401) {
          Vue.notify({
            group: 'notifications',
            type: 'error',
            title: 'Unauthorized',
            text: 'Content only for register.'
          })

          _authService.logout()
          router.push('/login')
        }
        if (error.response.status === 403) {
          Vue.notify({
            group: 'notifications',
            type: 'error',
            title: 'Forbidden',
            text: 'You do not have access.'
          })

          if (router.currentRoute.path !== '/') {
            router.push('/')
          }
        }

        Vue.notify({
          group: 'notifications',
          type: 'error',
          title: error.response.status,
          text: error.response.message
        })
      }
      (window as any).NProgress.done()
    })
  }
}
